export function getDisplayName(WrappedComponent): string {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
